import { apiClient } from '@/utils/api-client';
import type { ApiResponse, JsonApiResource } from '@/types/api';

export interface Domain {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  system_prompt_guidance: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface DomainCreateData {
  slug: string;
  name: string;
  description?: string;
  system_prompt_guidance?: string;
  is_active?: boolean;
  sort_order?: number;
}

export interface DomainUpdateData {
  slug?: string;
  name?: string;
  description?: string;
  system_prompt_guidance?: string;
  is_active?: boolean;
  sort_order?: number;
}

export const domainService = {
  async list(params?: { active?: string }): Promise<ApiResponse<JsonApiResource<Domain>[]>> {
    const queryParams: Record<string, string> = {};
    if (params?.active) queryParams.active = params.active;
    return apiClient.get('/api/admin/domains', queryParams);
  },

  async get(id: string): Promise<ApiResponse<JsonApiResource<Domain>>> {
    return apiClient.get(`/api/admin/domains/${id}`);
  },

  async create(data: DomainCreateData): Promise<ApiResponse<JsonApiResource<Domain>>> {
    return apiClient.post('/api/admin/domains', { domain: data });
  },

  async update(id: string, data: DomainUpdateData): Promise<ApiResponse<JsonApiResource<Domain>>> {
    return apiClient.patch(`/api/admin/domains/${id}`, { domain: data });
  },

  async destroy(id: string): Promise<void> {
    return apiClient.delete(`/api/admin/domains/${id}`);
  },
};
